<template>
  <div class="product-students-change-password-modal p-5">
    <form v-if="student" autocomplete="new-password" @submit.prevent="submit">
      <h5 class="mb-6">
        Alterar senha de {{ student.name }} ({{ student.email }})
      </h5>

      <form-group
        v-model="form.password"
        :errors="errors.password"
        id="password"
        type="password"
        label="Nova senha"
        placeholder="Digite a nova senha do usuário"
        disable-autocomplete
      />

      <div class="d-flex flex-column flex-lg-row mx-n3 pl-5 pr-5 pt-5">
        <button
          class="btn btn-secondary btn-block px-9 my-3 mr-lg-3"
          @click="$emit('close')"
          type="button"
        >
          Cancelar
        </button>
        <div class="flex-fill"></div>
        <button
          class="btn btn-primary btn-block px-9 my-3 ml-lg-3"
          type="submit"
        >
          <loading :show="loading">
            Salvar
          </loading>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers";

export default {
  props: {
    student: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      ...formFields(["password", "id"], {
        id: this.student.id
      })
    };
  },
  methods: {
    submit() {
      this.loading = true;

      this.$store
        .dispatch("membersStudents/changePassword", this.form)
        .then(() => {
          this.$message.success("Salvo com sucesso");
          this.$emit("close");
        })
        .catch(error => {
          this.errors = error.response.data;
          this.$message.error("Ocorreu um erro ao trocar a senha do aluno.");
          this.loading = false;
        });
    }
  }
};
</script>
